module.exports = __webpack_public_path__ + "static/media/tpn-events-slider.c36d4845.jpg";